/**
 * Created by danilaeremin on 11.08.15.
 */

/**
 * @class Layer for push robot settings.
 * @extends PlayerRobotSettingsLayer
 * @constructor
 * @param {pm.AbstractRobot} robot Robot which settings need to display.
 */
var PushRobotSettingsLayer = PlayerRobotSettingsLayer.extend(/** @lends PushRobotSettingsLayer# */{
	ctor: function(robot)
	{
		this._super(robot);

		this._label.setString(LocalizedString("Push") + " " + robot.id + ", " + LocalizedString("Pattern") + " " + robot.parentLevel.programData[robot.groupID].currentIndex);
	}
});
